// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 959px) {\n.doc-upload-wrapper {\n    padding-bottom: 86px;\n}\n}", ""]);
// Exports
module.exports = exports;
